import { AppState, Dispatch } from '../../types';
import { connect } from 'react-redux';
import * as actions from './actions'
import * as selectors from '../Reports/selectors';
import { ResourceSelectorContainer } from '../ResourceSelector/model';
import * as resourceSelectorActions from '../ResourceSelector/actions';
import { selectors as authSelectors } from '../../lifecycle/auth';
import { EventProps, ReportsLandingPage, ValueProps } from './ReportsLandingPage';

const mapProps = (state: AppState): ValueProps => ({
  organizationId: authSelectors.getOrganizationId(state),
  selectedEnvironment: selectors.getSelectedEnvironment(state),
  environments: selectors.getAllEnvironments(state),
  environmentsLoading: selectors.getEnvironmentsLoading(state),
  allBusinessGroupEnabled: window.mc.featureFlags.reports.allBusinessGroups.enabled === 'true'
});

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  fetchApplicationsData: (organizationId: string, envId: string, selectedType: string, dateRange: any) =>
      dispatch(actions.fetchApplicationsData(organizationId, envId, selectedType, dateRange)),
  fetchEnvironments: (resourceSelectorContainer: ResourceSelectorContainer) =>
    dispatch(resourceSelectorActions.fetchEnvironments(resourceSelectorContainer)),
  selectEnvironment: (resourceSelectorContainer: ResourceSelectorContainer) =>
    dispatch(resourceSelectorActions.selectEnvironments(resourceSelectorContainer)),
});

export default connect(mapProps, mapDispatch)(ReportsLandingPage)
